import type { MuiIconButtonProps } from '@packages/shared';
import { MuiIconButton } from '@packages/shared';

export interface ImageGalleryCallToActionButtonProps extends MuiIconButtonProps {
  children: React.ReactNode;
}

/**
 * <p>
 * This component is used as Wrapper for the ImageGalleryCallToActionButton.
 * </p>
 */

export const ImageGalleryCallToActionButton = ({
  children,
  sx,
  ...rest
}: ImageGalleryCallToActionButtonProps) => (
  <MuiIconButton
    {...rest}
    sx={{
      ...sx,
      width: '40px',
      height: '40px',
      backgroundColor: 'text.light',
      boxShadow: 6,
      touchAction: 'manipulation',
    }}
  >
    {children}
  </MuiIconButton>
);
